import React, { FunctionComponent } from "react";

import Alert from "../Alert";

const GenericError: FunctionComponent<{ message?: string }> = ({ message }) => (
  <Alert variant="danger" className="ds-mb-7" message={message ?? "An error occurred whilst loading this data."} />
);

export default GenericError;
